/**
 * возвращает индекс адреса для подстановки в point_id и сортировки roure_points
 * source всегда идет нулевым
 * */
export function getIndex(key: string, keyIndex: number, length: number): number {
  if (key === 'source') {
    return 0
  }
  if (key === 'return') {
    return length - 1
  }

  return Number(key.split('_')[1]) || keyIndex
}
